import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useContentOverflow,
  useCopyToClipboard,
  useNotification,
} from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import {
  PROFILE_USER_CARD_COPY_NOTIFICATION_KEY,
  PROFILE_USER_CARD_COPY_RESET_TIMEOUT,
  PROFILE_USER_CARD_COPY_TOOLTIP_KEY,
} from '../ProfileUserInfoItemCard.constants'
import {
  getProfileUserCardContactIcon,
  isProfileUserCardCopyableContactType,
  isProfileUserCardEmailContactType,
} from '../ProfileUserInfoItemCard.utils'
import { ProfileUserInfoItemCardContactRowContent } from '../ProfileUserInfoItemCardContactRowContent'

function ProfileUserInfoItemCardContactRow({ contact }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const [copied, setCopied] = useState(false)

  const [, copy] = useCopyToClipboard({
    onSuccess: handleSuccessCopy,
  })

  const ContactIcon = getProfileUserCardContactIcon(contact.type)
  const isCopyableContact =
    isProfileUserCardCopyableContactType(contact.type) && Boolean(contact.value)

  const copyTooltipKey = isProfileUserCardEmailContactType(contact.type)
    ? PROFILE_USER_CARD_COPY_TOOLTIP_KEY.email
    : PROFILE_USER_CARD_COPY_TOOLTIP_KEY.phone

  function handleSuccessCopy() {
    setCopied(true)

    handleAddSuccessNotification(
      isProfileUserCardEmailContactType(contact.type)
        ? PROFILE_USER_CARD_COPY_NOTIFICATION_KEY.email
        : PROFILE_USER_CARD_COPY_NOTIFICATION_KEY.phone
    )

    setTimeout(() => {
      setCopied(false)
    }, PROFILE_USER_CARD_COPY_RESET_TIMEOUT)
  }

  function handleCopy(event) {
    if (isCopyableContact && !copied) {
      stopPropagation(event)
      copy(contact.value)
    }
  }

  // The value shows its full text on hover only when truncated; the copy button
  // keeps its own "Click to copy"/"Copied" hint.
  const valueTooltip = overflow ? contact.value : null
  const copyTooltip = copied
    ? t(PROFILE_USER_CARD_COPY_TOOLTIP_KEY.copied)
    : t(copyTooltipKey)

  return (
    <ProfileUserInfoItemCardContactRowContent
      ContactIcon={ContactIcon}
      contact={contact}
      contactValueRef={setContentOverflowRef}
      copied={copied}
      copyTooltip={isCopyableContact ? copyTooltip : null}
      isCopyableContact={isCopyableContact}
      valueTooltip={valueTooltip}
      onCopy={handleCopy}
    />
  )
}

export default ProfileUserInfoItemCardContactRow
